import { render, staticRenderFns } from "./DoctorSettingInfo.vue?vue&type=template&id=3270cda8&scoped=true"
import script from "./DoctorSettingInfo.vue?vue&type=script&lang=js"
export * from "./DoctorSettingInfo.vue?vue&type=script&lang=js"
import style0 from "./DoctorSettingInfo.vue?vue&type=style&index=0&id=3270cda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270cda8",
  null
  
)

export default component.exports